import { Component } from '@angular/core';
import { PaginatedData } from 'src/app/models/paginatedData';
import { PaginationObject } from 'src/app/models/paginationObject';

@Component({
  selector: 'app-variable-compensation',
  templateUrl: './variable-compensation.component.html',
  styleUrls: ['../dashboard.component.scss']
})
export class VariableCompensationComponent {
  public data: PaginatedData;
  public pagination = new PaginationObject();
  public navigation = [
    { link: '/dashboard', svg: 'assets/ico/arrow-to-left-regular.svg', title: 'BACK' },
    {
      link: 'general',
      svg: 'assets/ico/compensation.svg',
      title: 'dashboard.menu.variablecompensationSubmenu.general.title',
      permission: { section: 'variablecompensation', subsection: 'general', pertinence: 'subsection', context: 'metadata', type: 'READER' },
    },
  ];
}
